// // Use $ instead of jQuery without replacing global $
(function ($) {

  $(document).ready(function () {
    $('.event-col-grid .grid-wrapper .card-box .card-body .inner-content h4').matchHeight({byRow: 0});
    $('.event-col-grid .grid-wrapper .card-box .card-body .inner-content').matchHeight();

    // if($('.event-col-grid').length > 0){
    limit_lines('body .event-col-grid .grid-wrapper .card-box .card-body .inner-content p', 3);
    limit_lines('body .event-col-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);
    // }

  });

  $(window).on("resize", function () {
    // if($('.event-col-grid').length > 0){
    //   limit_lines('body .event-col-grid .grid-wrapper .card-box .card-body .inner-content p', 3);
    //   limit_lines('body .event-col-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);
    // }
  }).resize();

})(jQuery);